module.exports = __webpack_public_path__ + "img/login-2.734fe87e.jpg";